import React from 'react';
import './MobAccountPages.scss';
import { MobBreadcrumbs } from './MobBreadcrumbs';

export function MobAccountPageShell({ title, breadcrumbs, children }) {
    const crumbs = breadcrumbs || [
        { label: 'Home', path: '/' },
        { label: title, path: null },
    ];

    return (
        <div className="mob-account-page">
            <MobBreadcrumbs items={crumbs} className="mob-account-page__breadcrumbs" />
            <div className="mob-account-page__body">{children}</div>
        </div>
    );
}
